import { Container} from 'themes/MoGrid';
import { Wrapper, PartnerContainer } from './Partners.styles';
import { IsOnMobile } from 'components/utils/helper';
import { PartnerRenderConfig, PartnersDetails } from './Partners.models';
import PartnersRow from './PartnersRow';

function Partners({ partners }: PartnersDetails) {
    const isOnMobile = IsOnMobile();
    // change config as need so that what types of partners need to be renderd and how many logos need to be shown at a instance in mobile or in desktop
    const renderingPartnersConfig: PartnerRenderConfig[] = [
        { type: 'major', displayLogoCount: isOnMobile? 4 : 4 },
        { type: 'official', displayLogoCount: isOnMobile? 4 : 4 },
        { type: 'promo', displayLogoCount:  isOnMobile? 2 : 2 },
        { type: 'fund', displayLogoCount:  isOnMobile? 2 : 2 },
    ]

    return (
        <Wrapper>
            <PartnerContainer>
                <Container>
                    {partners.map((partner, i) => {
                        // render the partners only avilable in "renderingPartnersConfig"
                        const partnerRenderConfig = renderingPartnersConfig.find((config) => config.type === partner.type);
                        if (partnerRenderConfig && partnerRenderConfig.displayLogoCount > 0 && partner.items && partner.items.length > 0) {
                            return (
                                <PartnersRow key={partner.type} {...partner} partnerRenderConfig={partnerRenderConfig} />
                            )
                        } else {
                            return <></>
                        }
                    }
                    )}
                </Container>
            </PartnerContainer>
        </Wrapper>
    )
}

export default Partners